import { FlexColCenVer } from '@/UI/styles';
import { MediaPlayerControlsRow } from './MediaPlayerControlsRow';
import type { TrimMediaPlayerControlsProps } from './types';

/**
 * Player controls without a scrubber, for nodes that provide their own scrubbing surface — the Trim
 * node scrubs on its filmstrip, so a second timeline here would be a redundant, conflicting control.
 */
export function TrimMediaPlayerControls({
  currentTime,
  duration,
  fps,
  isPaused,
  isMuted,
  hasAudio,
  showFrameStepButtons = true,
  timeInputVariant = 'timecode',
  timeDisplayMode,
  onTimeDisplayModeChange,
  onTogglePlay,
  onSetTime,
  onToggleMute,
}: TrimMediaPlayerControlsProps) {
  return (
    <FlexColCenVer sx={{ py: 2, width: '100%' }}>
      <MediaPlayerControlsRow
        currentTime={currentTime}
        duration={duration}
        fps={fps}
        isPaused={isPaused}
        isMuted={isMuted}
        hasAudio={hasAudio}
        showFrameStepButtons={showFrameStepButtons}
        timeInputVariant={timeInputVariant}
        timeDisplayMode={timeDisplayMode}
        onTimeDisplayModeChange={onTimeDisplayModeChange}
        onTogglePlay={onTogglePlay}
        onSetTime={onSetTime}
        onToggleMute={onToggleMute}
      />
    </FlexColCenVer>
  );
}
